// Store stable chapter/control indices so locale re-renders can replace the DOM.
export function captureReadingPosition(trigger,scrollY){
 const section=trigger?.closest('section[id]');
 if(!section||section.id==='lab')return null;
 const controls=[...section.querySelectorAll('button,a')];
 return {sectionId:section.id,controlIndex:controls.indexOf(trigger),controlTop:trigger.getBoundingClientRect().top,sectionTop:section.getBoundingClientRect().top,scrollY};
}
export function restoreReadingPosition(bookmark,document,scrollY){
 if(!bookmark)return null;
 const section=document.getElementById(bookmark.sectionId);if(!section)return null;
 const control=[...section.querySelectorAll('button,a')][bookmark.controlIndex];
 const anchor=control||section,offset=control?bookmark.controlTop:bookmark.sectionTop;
 return {top:Math.max(0,scrollY+anchor.getBoundingClientRect().top-offset),focus:control||null};
}
